export const createFormData = (obj) => {
    const formData = new FormData();
    const appendToForm = (data, parentKey = '') => {
        Object.entries(data || {}).forEach(([key, value]) => {
            const fieldName = parentKey ? `${parentKey}[${key}]` : key;

            if (value instanceof File) {
                formData.append(fieldName, value);
            } else if (
                value !== null &&
                typeof value === 'object' &&
                !(value instanceof Date) &&
                !(value instanceof File)
            ) {
                appendToForm(value, fieldName);
            } else {
                formData.append(fieldName, value ?? '');
            }
        });
    };

    appendToForm(obj);
    return formData;
};
